import React, { useState, useEffect } from "react";
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import './App.css';
import Navbar from './Navbar';
import NewHome from './NewHome.js';
import AcquisitionLanding from './AcquisitionLanding.js';
import Resources from './Resources';
import Product from './Product';
import Newpricing from './Newpricing';
import { useTranslation } from 'react-i18next';
import i18n from './i18n.js';
import BlogPage from './BlogPage';
import blogNewsData from './blogNewsData.js';
import useGeoLocation from "react-ipgeolocation";
import ProductPageDashboard from "./ProductPageDashboard.js";
import ProductPageVisitor from "./ProductPageVisitor.js";
import Login from './Login';
import BlogCreator from './BlogCreator';
import BlogList from './BlogList';
import VSRoasberryComparison from './VSRoasberryComparison.js'; // Import the comparison component
import ScrollToTop from './ScrollToTop'; // Import the ScrollToTop component
import ResourcesBlog from "./ResourcesBlog.jsx";
import ResourcesTech from "./ResourcesTech.jsx";

function App() {
  const [topBarHeight, setTopBarHeight] = useState(0);
  const { t } = useTranslation();
  const [consentAccepted, setConsentAccepted] = useState(localStorage.getItem('cookiesConsent') === 'true');
  const [languageSet, setLanguageSet] = useState(false); // To avoid infinite loop
  const [isLoggedIn, setIsLoggedIn] = useState(false); // New state for login
  const [blogData, setBlogData] = useState(blogNewsData); // Initial blog data

  const handleAccept = () => {
    localStorage.setItem('cookiesConsent', 'true');
    setConsentAccepted(true);
  };

  const location = useGeoLocation();
  console.log("LOCATION" + location.country)
  useEffect(() => {
    if (!languageSet && location.loaded && !location.error) {
      const country = location.country;
      if (country === 'TR') {
        i18n.changeLanguage('tr');
      } else {
        i18n.changeLanguage('en');
      }
      setLanguageSet(true); // Mark language as set to avoid re-running
    }
  }, [location, languageSet]);

  useEffect(() => {
    // Don't apply overflow hidden for acquisition landing page since it doesn't show cookie banner
    const isAcquisitionPage = window.location.pathname === '/' || window.location.pathname === '/Home';
    if (isAcquisitionPage) {
      document.body.style.overflow = 'visible';
    } else {
      document.body.style.overflow = consentAccepted ? 'visible' : 'hidden';
    }
  }, [consentAccepted]);

  const handleLogin = (status) => {
    setIsLoggedIn(status);
  };

  const handleCreateBlog = (newBlog) => {
    setBlogData([...blogData, newBlog]);
  };

  return (
    <div className={`app`}>
      <div className={`container-app`}>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<AcquisitionLanding />} />
            <Route path="/Home" element={<AcquisitionLanding />} />
            <Route path="/old-home" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                <NewHome />
              </>
            } />
            <Route path="/comparison/:dataId" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                <VSRoasberryComparison />
              </>
            } />
            <Route path="/Product" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                <Product />
              </>
            } />
            <Route path="/Pricing" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                <Newpricing />
              </>
            } />
            <Route path="/BlogPage/:newsTitle" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                <BlogPage blogNewsData={blogData} />
              </>
            } />
            <Route path="/dashboard-and-insight-tools" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                <ProductPageDashboard />
              </>
            } />
            <Route path="/visitor-insights-log" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                <ProductPageVisitor />
              </>
            } />
            <Route path="/Blog" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                <ResourcesBlog />
              </>
            } />
            <Route path="/OurTechnology" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                <ResourcesTech />
              </>
            } />

            {/* New Routes for Blog Creation and Login */}
            <Route path="/login" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                <Login onLogin={handleLogin} />
              </>
            } />
            <Route path="/create-blog" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                {isLoggedIn ? <BlogCreator onCreate={handleCreateBlog} /> : <Login onLogin={handleLogin} />}
              </>
            } />
            <Route path="/blog-list" element={
              <>
                <Navbar setTopBarHeight={setTopBarHeight} />
                {isLoggedIn ? <BlogList blogData={blogData} /> : <Login onLogin={handleLogin} />}
              </>
            } />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
